/**
 * The body contains the functional payload for creating a service order.
 */
import { OrderCustomerInformation } from './order-customer-information';
import { ServiceOrder } from './service-order';
import { OrderVehicleInformation } from './order-vehicle-information';

export class CreateServiceOrderRequestBody {
  customerInformation: OrderCustomerInformation;
  serviceOrder: ServiceOrder;
  vehicleInformation: OrderVehicleInformation;
}
